module.exports = __webpack_public_path__ + "static/media/email-sent.a9bff0eb.svg";